import { colorScales } from "@octopusdeploy/design-system-tokens";
import { iconStyle, type LiveStatusIconSize } from "../LiveAppIcons";
export function DegradedIcon(size: LiveStatusIconSize) {
    return (<span role="img" className={iconStyle(size)} style={{ background: colorScales.red[500] }}>
            <em className="fa-solid fa-heart-crack"/>
        </span>);
}
